import * as Yup from 'yup';
import { IOptionType } from '../../helper';

export interface IReportFileFormValues {
    report : IOptionType | null;
    site : IOptionType | null;
    printServer : IOptionType | null;
}

export class ReportFileFormValues implements IReportFileFormValues {
    public report : IOptionType | null;
    public site : IOptionType | null;
    public printServer : IOptionType | null;

    public constructor() {
        this.initializeDefaultValues();
    }

    public initializeDefaultValues = () => {
        return {
            report: null,
            site: null,
            printServer: null,
        };
    };

    // Validation schema used by formik. https://github.com/jquense/yup
    public static formSchema = Yup.object().shape({
    });
}
